<template>
    <div style="min-height: 100vh; background-color: #0f172b">
        <PageContent urlPath="/maintenance" />
    </div>
</template>
<script>
const baseUrl = import.meta.env.VITE_BASE_URL;
import PageContent from "@/components/crane/builderio/PageContent.vue";

// import FooterComponent from "@/components/layout/footer/FooterComponent.vue";
export default {
    name: "Maintenance",
    data: () => ({}),
    components: {
        PageContent,

        // FooterComponent,
    },
    computed: {
        maintenanceModeFlag: function () {
            return this.$route.params.disableId;
        },
    },
    created() {
        if (this.maintenanceModeFlag) {
            localStorage.setItem("craneMaintenanceModeFlag", this.maintenanceModeFlag);
        }
    },
};
</script>
